import React from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { makeStyles } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import GroupAddIcon from "@material-ui/icons/GroupAdd";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
  spacing: {
    marginTop: -7,
  },
}));

interface Props {
  rates: number[];
  update: (dependant: number, rate: number, amount: number) => void;
  custom?: boolean;
}

const FitrahCalculator = ({ update, rates, custom }: Props) => {
  const classes = useStyles();

  const [count, setCount] = React.useState<number>(1);
  const [rate, setRate] = React.useState<number>(rates[0]);

  const onCountChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    let n = parseInt(evt.target.value);

    setCount(n);
    update(n, rate, n * rate);
  };

  const onRateChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    let n = Number(event.target.value as string);

    setRate(n);
    update(count, n, count * n);
  };

  let rate_field: React.ReactNode | null = null;
  if (custom) {
    rate_field = (
      <TextField
        required
        error={rate < rates[0]}
        helperText={`Pastikan nilai fitrah sekurang-kurangnya RM ${rates[0]}`}
        type="number"
        id="rate"
        name="rate"
        fullWidth
        onChange={onRateChange}
        value={(0 + rate).toString()}
        InputProps={{
          startAdornment: <InputAdornment position="start">RM</InputAdornment>,
        }}
      />
    );
  } else {
    rate_field = (
      <Select value={rate} onChange={onRateChange}>
        {rates.map((rate) => (
          <MenuItem key={rate} value={rate}>
            RM {rate}
          </MenuItem>
        ))}
      </Select>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} sm={6}>
        <TextField
          required
          error={count < 1}
          helperText="Pastikan nilai tanggungan sekurang-kurangnya 1"
          id="dependent"
          name="dependent"
          label="Tanggungan"
          fullWidth
          type="number"
          value={count.toString(10)}
          onChange={onCountChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <GroupAddIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6} className={classes.spacing}>
        <FormControl className={classes.formControl}>
          <FormHelperText>Nilai Fitrah</FormHelperText>
          {rate_field}
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default FitrahCalculator;
